module.exports = __webpack_public_path__ + "media/lobby_selfintro.aef3735c.mp3";